import { withRouter } from "react-router-dom";

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';

import {
  Typography, IconButton, Grid, InputBase, Avatar, Box, Paper, Button
} from '@mui/material';

import { FiSearch, FiArrowUp, FiArrowDown, FiFilter, FiGrid, FiStar } from 'react-icons/fi';

function FilterPage(props) {
  const [viewMainProduct, setViewMainProduct] = useState([]);
  const [order, setOrder] = useState('')
  const [sorting, setSorting] = useState('')
  const [search, setSearch] = useState('')
  const [token] = useState(localStorage.getItem("jwt"))
  const apiMainProduct = 'http://localhost:8080/api/product/produtos'

  const fetchMainProduct = async () => {
    const result = await axios.post(apiMainProduct)
      .then((res) => {
        console.log(res.data)
        setViewMainProduct(res.data.produtos)
      })
  }

  const funSearch = (e) => {
    e.target.name = e.target.value
    setSearch(e.target.name, console.log(search))
  }

  const submitSearch = () => {
    setSearch(search)
    fetchMainProduct()
  }

  const changeSort = (checkSort) => {
    setSorting(checkSort)
    fetchMainProduct()
  }

  const changeOrder = (checkOrder) => {
    setOrder(checkOrder)
    fetchMainProduct()
  }

  useEffect(() => {
    fetchMainProduct();
  }, []);

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', maxWidth: '98%', mx: 'auto' }}>
        <Box sx={{ py: 2.5, px: { xs: 2, md: 3 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
              <FiFilter size={18} />
            </Avatar>
            <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
              Filtros de Produto
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        {/* Filter Buttons */}
        <Paper sx={{
          p: { xs: 2.5, md: 3 },
          borderRadius: 2.5,
          border: '1px solid',
          borderColor: 'grey.200',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          bgcolor: '#fff',
          mb: 3
        }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                onClick={() => changeOrder("name")}
                startIcon={<FiFilter size={16} />}
                sx={{
                  bgcolor: '#1a1a2e',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderRadius: 1.5,
                  py: 1.2,
                  '&:hover': { bgcolor: '#16213e' }
                }}
              >
                Filtrar por Nome
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                onClick={() => changeOrder("category")}
                startIcon={<FiGrid size={16} />}
                sx={{
                  bgcolor: '#1a1a2e',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderRadius: 1.5,
                  py: 1.2,
                  '&:hover': { bgcolor: '#16213e' }
                }}
              >
                Filtrar por Categoria
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                onClick={() => changeOrder("date_update")}
                startIcon={<FiStar size={16} />}
                sx={{
                  bgcolor: '#1a1a2e',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderRadius: 1.5,
                  py: 1.2,
                  '&:hover': { bgcolor: '#16213e' }
                }}
              >
                Filtrar por Novos Produtos
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {/* Search & Sort */}
        <Paper sx={{
          p: { xs: 2.5, md: 3 },
          borderRadius: 2.5,
          border: '1px solid',
          borderColor: 'grey.200',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          bgcolor: '#fff'
        }}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} md={8}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1.5,
                px: 1.5,
                '&:focus-within': { borderColor: '#1a1a2e' }
              }}>
                <IconButton onClick={submitSearch} size="small">
                  <FiSearch size={18} />
                </IconButton>
                <InputBase
                  placeholder="Procurar Produto..."
                  inputProps={{ 'aria-label': 'naked' }}
                  name="search"
                  onChange={funSearch}
                  sx={{ ml: 1, flex: 1, py: 1 }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton
                  onClick={() => changeSort("DESC")}
                  sx={{
                    border: '1px solid',
                    borderColor: 'grey.300',
                    borderRadius: 1.5,
                    '&:hover': { borderColor: '#1a1a2e' }
                  }}
                >
                  <FiArrowUp size={18} />
                </IconButton>
                <IconButton
                  onClick={() => changeSort("ASC")}
                  sx={{
                    border: '1px solid',
                    borderColor: 'grey.300',
                    borderRadius: 1.5,
                    '&:hover': { borderColor: '#1a1a2e' }
                  }}
                >
                  <FiArrowDown size={18} />
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  )
}
export default withRouter(FilterPage)
